import { Link, useLocation, useNavigate } from "react-router-dom"
import { Category, Logout as LogoutIcon, SmartHome, X } from "@/components/icons/outline"
import Logo from "@/components/graphics/logo"
import { useAuth } from "@/contexts/auth-context"

export default function MobileNav({ show = false, onClose }) {
    // Contexts
    const { user, logout } = useAuth()

    // Hooks
    const url = useLocation().pathname
    const navigate = useNavigate()

    const handleLogout = () => {
        logout()
        navigate(0)
    }

    return show ? (
        <div className="fixed top-0 z-50 flex flex-col w-full bg-white border-b">
            {/* Logo */}
            <div className="flex items-start justify-center w-full px-6 py-4">
                <Link to="/" className="">
                    <Logo className="w-6 h-6" strokeWidth={3} />
                </Link>
                <span className="flex-grow"></span>
                <button onClick={() => onClose()} className="p-1 bg-white border rounded-full opacity-100 md:opacity-0">
                    <X className="w-4 h-4" strokeWidth={2} />
                </button>
            </div>
            <div className="flex flex-col flex-grow text-neutral-400">
                <Link to="/" className={`relative px-6 py-2 hover:text-black flex items-center space-x-4 ${url === '/' ? 'bg-neutral-100 text-black' : ''}`}>
                    <SmartHome className="w-6 h-6" strokeWidth={2} />
                    <span className="font-semibold">Discover</span>
                </Link>
                {/* <button className="px-6 py-2 text-neutral-600 bg-neutral-200/50 rounded-xl">
                    <Plus className="w-6 h-6" strokeWidth={2} />
                </button> */}
                <Link to="/category" className={`relative px-6 py-2 hover:text-black flex items-center space-x-4 ${url === '/category' ? 'bg-neutral-100 text-black' : ''}`}>
                    <Category className="w-6 h-6" strokeWidth={2} />
                    <span className="font-semibold">Category</span>
                </Link>

                <div className="flex items-center justify-between p-4">
                    <Link to="/profile" className="relative">
                        <img className="w-10 h-10 rounded-full" src={`https://ui-avatars.com/api/?name=${user?.name}`} alt={`${user?.name}'s Profile Picture`} />
                    </Link>

                    <button onClick={handleLogout} className="p-2 text-red-500 bg-red-100 rounded-full pointer-events-auto">
                        <LogoutIcon className="w-7 h-7" strokeWidth={2} />
                    </button>
                </div>
            </div>
        </div>
    ) : null
}